import { Option } from './../../shared/model/option';

export enum DownloadMethodEnum {
    DOWNLOAD = 'DOWNLOAD',
    EMAIL = 'EMAIL'
}

export namespace DownloadMethodEnum {

    export function getOptions(): Option<DownloadMethodEnum>[] {
        return [
            { name: 'Direct Download', value: DownloadMethodEnum.DOWNLOAD },
            { name: 'E-mail', value: DownloadMethodEnum.EMAIL }
        ];
    }
}
